export default "__VITE_ASSET__b097f61f__"